import { Dialog, DialogPanel } from "@headlessui/react";
import { FC } from "react";

interface Props {
  open: boolean;
  panelClassName?: string;
  overrideBackground?: string;
  children: React.ReactNode;
  onClose: (value: boolean) => void;
}

export const DialogComponent: FC<Props> = ({ open, panelClassName = "", overrideBackground, onClose, children }) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div>
        <div className="fixed inset-0 backdrop-blur-xs" aria-hidden="true" />
        <div className="fixed inset-0 flex items-center justify-center p-4 overflow-y-auto">
          <DialogPanel
            className={`absolute ${overrideBackground ? overrideBackground : "bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark"} ${panelClassName}`}
          >
            {children}
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
};
